import script from "./Setup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Setup.vue?vue&type=script&setup=true&lang=ts"

import "./Setup.vue?vue&type=style&index=0&id=eddaa222&lang=scss&scoped=true"
import "../styles/native-auth.css?vue&type=style&index=1&id=eddaa222&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eddaa222"]])

export default __exports__